import { Init } from "@pdfking/reactivity/preact"
import { CreateSingleton, RecordAssign, UnixTime } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import { get_translations } from "@pdfking/workflow/utils/make_translations"
import translate from "@pdfking/workflow/utils/render_string"
import user_get from "../constants/user_get"
import on from "../dom/on"
import clear_ajax_cache from "../navigation/clear_ajax_cache"
import messages from "./messages"

export default CreateSingleton(() =>
  Init({
    computed: {
      is_just_staff() {
        return !!(this.id && this.is_staff)
      },
      is_just_user() {
        return !!(this.id && !this.is_staff)
      },
    },
    data: user_get(),
    methods: {
      refresh() {
        const new_state = user_get()

        if (this.has_discount !== new_state.has_discount) {
          clear_ajax_cache()
        }

        if (this.id !== new_state.id) {
          if (new_state.id) {
            get_translations("actions").then(actions =>
              messages().add(
                translate(actions.LOGIN, {
                  user: new_state.email || new_state.name || new_state.id,
                })
              )
            )
          }

          this.dispatch_event(false)
          clear_ajax_cache()
        }

        RecordAssign(this, new_state)
      },
      dispatch_event(initial = true) {
        if (this.id) {
          fire_event(document, "user_login", { initial })

          const current = UnixTime()

          if (current - (this.signup_time as number) <= 5) {
            fire_event(document, "user_signup", { initial })
          }
        } else {
          fire_event(document, "user_logout", { initial })
        }
      },
    },
    init() {
      on("site_init", null, () => this.dispatch_event())
    },
  })
)
